import { cn } from '@/lib/utils'
import { SLA_TARGETS, slaClockText, slaTargetLabels } from '@/lib/sla'
import type { SlaTone } from '@/lib/sla'
import { useNow } from '@/hooks/useNow'
import type { SlaSummary } from '@/types/ticket'

const slaToneText: Record<SlaTone, string> = {
  danger: 'text-etn-danger-text',
  warning: 'text-etn-warning-text',
  success: 'text-etn-success-text',
  neutral: 'text-etn-text-cell',
  muted: 'text-etn-text-soft',
}

// The rail's SLA block: where each clock stands, worded for a glance rather than a dashboard.
export function SlaClocks({ summary }: { summary: SlaSummary }) {
  const now = useNow()
  return (
    <div data-testid="sla-clocks" className="mb-2">
      <div className="mb-1.5 text-etn-micro font-semibold uppercase tracking-[0.05em] text-etn-text-label">SLA</div>
      {SLA_TARGETS.map(target => {
        const clock = summary[target]
        const { text, detail, tone } = slaClockText(clock, now)
        const agreed = target === 'resolution' && Boolean(summary.resolution.agreedDueDate)
        return (
          <div key={target} className="mb-1.5 flex items-start justify-between gap-2.5 text-etn-control" data-testid={`sla-${target}`}>
            <span
              className="text-etn-text-soft"
              title={agreed ? 'Due on the date agreed with the customer' : `Target: ${Number((clock.targetMinutes / 60).toFixed(2))} business hours`}
            >
              {slaTargetLabels[target]}
            </span>
            <span className="min-w-0 text-right">
              <span className={cn('block font-semibold', slaToneText[tone])}>{text}</span>
              {detail && <span className="block text-etn-micro text-etn-text-soft">{detail}</span>}
              {agreed && <span className="block text-etn-micro text-etn-text-soft">Agreed date</span>}
            </span>
          </div>
        )
      })}
    </div>
  )
}
